import React,{useEffect} from 'react'
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../services/api/api-urls'
import DeletedBaseProductManagementColumn from './deleted-base-product-column'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const DeletedBaseProductPage: any = (props: any) => {

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.BaseProduct,
    getAllUrl: 'BaseProduct/GetAllDeletedBaseProduct',
    title: props.title || 'Deleted Base Products',
    column: DeletedBaseProductManagementColumn(),
    isNotEditable: true,
    isNotDeletable: true,
    isNotAddable: true
  }
  // useEffect(() => {   
  //   document.title="Deleted Base Products"
  // }, [])
    useDocumentTitle();
  return (
    <>
      <CommonTablePage
        {...commonTablePageProps}
      />
    </>
  )
}

export default DeletedBaseProductPage
